(() => {
  const header = document.querySelector('[data-kc-header]');
  const setHeader = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  setHeader();
  window.addEventListener('scroll', setHeader, { passive: true });

  const drawer = document.querySelector('[data-mobile-drawer]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const openDrawer = () => {
    if (!drawer || !menuToggle) return;
    drawer.hidden = false;
    document.body.classList.add('no-scroll');
    menuToggle.setAttribute('aria-expanded', 'true');
  };
  const closeDrawer = () => {
    if (!drawer || !menuToggle) return;
    drawer.hidden = true;
    document.body.classList.remove('no-scroll');
    menuToggle.setAttribute('aria-expanded', 'false');
  };
  menuToggle?.addEventListener('click', openDrawer);
  menuClose?.addEventListener('click', closeDrawer);
  drawer?.addEventListener('click', (event) => {
    if (event.target.matches('a')) closeDrawer();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('[data-carousel-section]').forEach((section) => {
    const track = section.querySelector('[data-carousel-track]');
    const prev = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    if (!track) return;
    const scrollByAmount = () => Math.max(track.clientWidth * 0.84, 260);
    prev?.addEventListener('click', () => track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' }));
  });

  const facets = document.querySelector('[data-facets]');
  const facetToggle = document.querySelector('[data-facet-toggle]');
  const facetClose = document.querySelector('[data-facet-close]');
  facetToggle?.addEventListener('click', () => facets?.classList.add('is-open'));
  facetClose?.addEventListener('click', () => facets?.classList.remove('is-open'));

  const sortSelect = document.querySelector('[data-sort-select]');
  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
})();
/* ============================================================
   KICKS COLLECTIVE INFINITE SCROLL
============================================================ */

(function () {
  const infiniteWrap = document.querySelector('[data-kc-infinite-scroll]');
  const productGrid = document.querySelector('.kc-product-grid');

  if (!infiniteWrap || !productGrid) return;

  const loadButton = infiniteWrap.querySelector('[data-kc-load-more]');
  const status = infiniteWrap.querySelector('[data-kc-infinite-status]');

  let nextUrl = infiniteWrap.dataset.nextUrl;
  let isLoading = false;

  function setStatus(message) {
    if (status) status.textContent = message || '';
  }

  async function loadMoreProducts() {
    if (!nextUrl || isLoading) return;

    isLoading = true;
    setStatus('Loading more products...');

    if (loadButton) {
      loadButton.disabled = true;
      loadButton.textContent = 'Loading...';
    }

    try {
      const response = await fetch(nextUrl);

      if (!response.ok) {
        throw new Error('Could not load more products.');
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newProducts = doc.querySelectorAll('.kc-product-grid .kc-product-card');
      const newInfiniteWrap = doc.querySelector('[data-kc-infinite-scroll]');

      newProducts.forEach((productCard) => {
        productGrid.appendChild(productCard);
      });

      nextUrl = newInfiniteWrap ? newInfiniteWrap.dataset.nextUrl : '';

      if (!nextUrl) {
        infiniteWrap.remove();
      } else {
        infiniteWrap.dataset.nextUrl = nextUrl;

        if (loadButton) {
          loadButton.disabled = false;
          loadButton.textContent = 'Load more';
        }

        setStatus('');
      }
    } catch (error) {
      console.error(error);
      setStatus('Could not load more products. Tap again to retry.');

      if (loadButton) {
        loadButton.disabled = false;
        loadButton.textContent = 'Load more';
      }
    }

    isLoading = false;
  }

  if (loadButton) {
    loadButton.addEventListener('click', loadMoreProducts);
  }

  const observer = new IntersectionObserver(
    function (entries) {
      const entry = entries[0];

      if (entry.isIntersecting) {
        loadMoreProducts();
      }
    },
    {
      rootMargin: '700px 0px'
    }
  );

  observer.observe(infiniteWrap);
})();
/* ============================================================
   PRODUCT GALLERY THUMBNAIL SWITCHER
============================================================ */

(function () {
  const galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-main-product-image]');
    const thumbs = gallery.querySelectorAll('[data-product-thumb]');

    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullImage = thumb.dataset.full;
        const srcset = thumb.dataset.srcset;
        const alt = thumb.dataset.alt || '';

        if (fullImage) {
          mainImage.src = fullImage;
        }

        if (srcset) {
          mainImage.srcset = srcset;
        }

        mainImage.alt = alt;

        thumbs.forEach((item) => {
          item.classList.remove('is-active');
        });

        thumb.classList.add('is-active');
      });
    });
  });
})();
/* ============================================================
   KICKS COLLECTIVE MOBILE MENU
============================================================ */

(function () {
  const openButtons = document.querySelectorAll('[data-menu-toggle]');
  const closeButtons = document.querySelectorAll('[data-menu-close]');
  const drawer = document.querySelector('[data-mobile-drawer]');

  if (!drawer || !openButtons.length) return;

  function openMenu() {
    drawer.hidden = false;
    document.body.classList.add('no-scroll');
  }

  function closeMenu() {
    drawer.hidden = true;
    document.body.classList.remove('no-scroll');
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', openMenu);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !drawer.hidden) {
      closeMenu();
    }
  });
})();
/* ============================================================
   PRODUCT DESCRIPTION SEE MORE TOGGLE
============================================================ */

(function () {
  const descriptionBlocks = document.querySelectorAll('[data-product-description]');

  descriptionBlocks.forEach((block) => {
    const button = block.querySelector('[data-product-description-toggle]');
    const content = block.querySelector('[data-product-description-content]');

    if (!button || !content) return;

    button.addEventListener('click', () => {
      const isExpanded = block.classList.toggle('is-expanded');

      button.textContent = isExpanded ? 'See less' : 'See more';
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
  });
})();
/* ============================================================
   SEARCH BAR CLEAR BUTTON
============================================================ */

(function () {
  const searchInputs = document.querySelectorAll('[data-kc-search-input]');

  searchInputs.forEach((input) => {
    const form = input.closest('form');
    if (!form) return;

    const clearButton = form.querySelector('[data-kc-search-clear]');
    if (!clearButton) return;

    function updateClearButton() {
      if (input.value.trim().length > 0) {
        clearButton.hidden = false;
      } else {
        clearButton.hidden = true;
      }
    }

    clearButton.addEventListener('click', function () {
      input.value = '';
      input.focus();
      updateClearButton();

      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    input.addEventListener('input', updateClearButton);
    input.addEventListener('change', updateClearButton);

    updateClearButton();
  });
})();